export enum TimeOffType {
  VACATION = "VACATION",
  ILLNESS = "ILLNESS",
  STUDY = "STUDY",
  OTHER = "OTHER",
  BIRTHDAY = "BIRTHDAY",
  HOLIDAY = "HOLIDAY",
}

export enum TimeOffStatus {
  PENDING = "PENDING",
  ADD_DOCUMENTATION = "ADD_DOCUMENTATION",
  PENDING_CANCELLATION = "PENDING_CANCELLATION",
  APPROVED = "APPROVED",
  CANCELLED = "CANCELLED",
  REJECTED = "REJECTED",
}

export const timeoffOptions = [
  {
    label: "Planned Vacation",
    value: TimeOffType.VACATION,
  },
];
